import React, { useState, useEffect } from "react";
import { Filter } from "lucide-react";
import "./Portfolio.css";

const Portfolio = () => {
  const [activeFilter, setActiveFilter] = useState("Tous");
  const [filteredServices, setFilteredServices] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  //Photo page portfolio
const services = [
  {
    category: 'Peinture',
    images: [
      { url: '/images/peinture.jpg', alt: 'Peinture 1' }
    ]
  },
  {
     category: 'Peinture à la chaux',
    images: [
      { url: '/images/peinture-chaux.jpg', alt: 'peinture chaux' }
     ]
   },
  {
    category: 'Argile sablé',
    images: [
      { url: '/images/argile-sab1.jpg', alt: 'Argile sab 1' },
      { url: '/images/argile-sab2.jpg', alt: 'Argile sab 2' }
    ]
  },
  {
    category: 'Argile finition',
    images: [
      { url: '/images/argile-finit1.jpg', alt: 'Argile finit 1' }
    ]
  },
  {
    category: 'Parquet',
    images: [
      { url: '/images/parquet.jpg', alt: 'Parquet 1' }
    ]
  },
  {
    category: 'Claustra',
    images: [
      { url: '/images/claustra.jpg', alt: 'Claustra 1' }
    ]
  },
  {
    category: 'Plaque de plâtre / Enduit ',
    images: [
      { url: '/images/platre.jpg', alt: 'Plaque de plâtre ' },
      { url: '/images/enduit.jpg', alt: 'Plaque de plâtre ' }
    ]
  },
  {
    category: 'Faux plafond',
    images: [
      { url: '/images/faux-plafond.jpg', alt: 'Faux plafond' }
    ]
  },
  {
    category: 'Cloison',
    images: [
      { url: '/images/cloison.jpg', alt: 'Cloison 1' }
    ]
  },
];

  const categories = ["Tous", ...services.map((s) => s.category)];

  useEffect(() => {
    if (activeFilter === "Tous") {
      setFilteredServices(services);
    } else {
      setFilteredServices(services.filter((s) => s.category === activeFilter));
    }
   
  }, [activeFilter]);

  return (
    <div className="portfolio-page">
      {/* Header */}
      <section className="portfolio-header">
        <div className="container">
          <h1 className="fade-in">Portfolio</h1>
          <div className="header-underline"></div>
          <p className="fade-in">
            Découvrez nos réalisations et notre savoir-faire
          </p>
        </div>
      </section>

      {/* Filtre */}
      <section className="filter-section">
        <div className="container">
          <div className="filter-header">
            <Filter size={20} />
            <span>Filtrer par service</span>
          </div>
          <div className="filter-buttons">
            {categories.map((category) => (
              <button
                key={category}
                className={`filter-btn ${
                  activeFilter === category ? "active" : ""
                }`}
                onClick={() => setActiveFilter(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Galerie */}
      <section className="gallery-section">
        <div className="container">
          {filteredServices.map((service, serviceIndex) => (
            <div key={serviceIndex} className="service-gallery fade-in">
              <h2 className="service-title">{service.category}</h2>
              <div className="images-grid">
                {service.images.map((image, imageIndex) => (
                  <div
                    key={imageIndex}
                    className="gallery-item scale-in"
                    style={{ animationDelay: `${imageIndex * 0.1}s` }}
                  >
                    <img src={image.url} alt={image.alt} />
                    <div className="gallery-overlay">
                      <span>{service.category}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Portfolio;
 